import AchievementLogo from '../../../images/AOlogo.png';
import LeadershipLogo from '../../../images/LEOlogo.png';
import LearningLogo from '../../../images/LOlogo.png';
import NurturingLogo from '../../../images/NOlogo.png';
import RelationshipLogo from '../../../images/ROlogo.png';
import SwotIcon from '../../../images/swotIcon.png';
import FocusAreaIcon from '../../../images/focusAreasIcon.png';
import lifeIcon from '../../../images/lifeIcon.png';
import involvementIcon from '../../../images/involvementIcon.png';
import disciplineIcon from '../../../images/disciplineIcon.png';


export default function buttonDataFormater(props,data,option) {
    var temp = []
    if(option == 'swot_orientation') {
        data.map((obj,key) => {
            temp.push({
                // img: `https://uat-analytics.discoverself.com/images/orientations/${obj.orientation_name == "Relationship" ? "sociability" : obj.orientation_name == "Nurturing" ? "integrity" : obj.orientation_name.toLowerCase()}.png`,
                img: obj.orientation_name == "Relationship" ? RelationshipLogo : obj.orientation_name == "Nurturing" ? NurturingLogo : obj.orientation_name === 'Leadership' ? LeadershipLogo : obj.orientation_name === 'Achievement' ? AchievementLogo : LearningLogo,
                link: `/organisation/${props.match.params.id}/user/swot/${obj.id}`,
                name: `${obj.orientation_name}`,
                id: obj.id,
                tooltip_id:obj.id
            })
        })
        return temp
    }
    if(option == 'swot_each') {
        data.map((obj,key) => {
            temp.push({
                img: `${obj.header_background_image}`,
                link: `${obj.link}`,
                name: `${obj.header_text.toLowerCase()}`,
                id: obj.header_text.toLowerCase(),
                tooltip_id:obj.header_text.toLowerCase()
            })
        })
        return temp
    }
    if(option == 'focus_area_orientation') {
        data.map((obj,key) => {
            temp.push({
                // img: `https://uat-analytics.discoverself.com/images/orientations/${obj.orientation_name == "Relationship" ? "sociability" : obj.orientation_name == "Nurturing" ? "integrity" : obj.orientation_name.toLowerCase()}.png`,
                img: obj.orientation_name == "Relationship" ? RelationshipLogo : obj.orientation_name == "Nurturing" ? NurturingLogo : obj.orientation_name === 'Leadership' ? LeadershipLogo : obj.orientation_name === 'Achievement' ? AchievementLogo : LearningLogo,
                link: `/organisation/${props.match.params.id}/user/focus-area/orientations/${obj.orientation_name.toLowerCase()}`,
                name: `${obj.orientation_name}`,
                id: `${obj.orientation_name.toLowerCase()}`,
                tooltip_id:obj.id
            })
        })
        return temp
    }
    if(option == 'focus_area_all') {
        data.map((obj,key) => {
            temp.push({
                // img: `https://uat-analytics.discoverself.com/images/focusAreas/${obj.id}Icon.png`,
                img: obj.id === 'life' ? lifeIcon : obj.id  === 'involvement' ? involvementIcon : disciplineIcon,
                link: `/organisation/${props.match.params.id}/user/focus-area/all/${obj.id}`,
                id:`${obj.id}`,
                name: `${obj.header_text.charAt(0).toUpperCase() + obj.header_text.toLowerCase().slice(1)}`,
                tooltip_id: `${key + 1}`,
            },)
        })
        return temp
    }
    if(option == 'l&d_all_button') {
        data.map((obj,key) => {
            temp.push({
                img: obj.orientation_name == "Relationship" ? RelationshipLogo : obj.orientation_name == "Nurturing" ? NurturingLogo : obj.orientation_name === 'Leadership' ? LeadershipLogo : obj.orientation_name === 'Achievement' ? AchievementLogo : LearningLogo,
                link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/${obj.header_text == "Relationship" ? "sociability" : obj.header_text == "Nurturing" ? "integrity" : obj.header_text.toLowerCase()}/1`,
                id:`${obj.header_text == "Relationship" ? "sociability" : obj.header_text == "Nurturing" ? "integrity" : obj.header_text.toLowerCase()}`,
                name: `${obj.header_text}`,
                tooltip_id: `${key + 1}`,
            },)
        })
        return temp
    }
}


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/buttonDataFormater.js